const PROCESSING_DEAL_LINE_REGEX = /^Processing\s+(\d+)\s+of\s+(\d+)\b/i;

/**
 * Extracts the "Processing N of M" progress index from a status message line.
 * @param {string} line
 * @returns {number|null}
 */
function getProcessingDealIndex(line) {
  const match = String(line).trim().match(PROCESSING_DEAL_LINE_REGEX);
  if (!match) {
    return null;
  }
  return Number(match[1]);
}

/**
 * Sorts multi-line status messages so "Processing N of M ..." lines appear in
 * ascending order by N. Other lines keep their relative order and appear first.
 * @param {string[]} lines
 * @returns {string[]}
 */
export function sortStatusMessageLines(lines) {
  const other = [];
  const processing = [];

  lines.forEach((line, index) => {
    if (line === "") {
      other.push({ line, index });
      return;
    }

    const progressIndex = getProcessingDealIndex(line);
    if (progressIndex != null) {
      processing.push({ line, index, progressIndex });
    } else {
      other.push({ line, index });
    }
  });

  processing.sort((a, b) => {
    if (a.progressIndex !== b.progressIndex) {
      return a.progressIndex - b.progressIndex;
    }
    return a.index - b.index;
  });

  return [...other, ...processing].map(({ line }) => line);
}
